<template>
  <div class="px-6 py-2 flex items-center justify-between text-[10px] text-gray-400 border-t shrink-0" style="background: #F9F6F1; border-color: #E6E0D7;">
    <span>© {{ year }} · All patient data masked per HIPAA minimum-necessary</span>
    <span class="flex items-center gap-1.5">
      Powered by <span class="font-semibold" style="color: #F76734;">Kairon</span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'ClientFooter',
  computed: {
    year() {
      return new Date().getFullYear();
    },
  },
};
</script>
